import { apolloClient } from "@/plugins/vue-apollo.js";

const updateLandlord = async (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/landlord/api/mutations/update_landlord.graphql"),
      variables: variables,
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateLandlord };
